import React from "react";
export default function TermsOfService() {
  return (
    <div style={{ marginTop: "6rem" }} className="img">
      <div className="row justify-content-center text-center">
        <div className="col-md-10 col-lg-8">
          <div className="header-section">
            <h2 className="display-6 text-center pb-5 mb-4">
              Terms of <b>Service</b>
            </h2>
          </div>
        </div>
      </div>

      <div className="container">
        <p><strong>Effective Date:</strong> May 20, 2025 __ <strong>Last Updated:</strong> May 20, 2025</p>
        <h4>1. Use of Services</h4>
        <p>
          You agree to use our Services only for lawful purposes and in accordance with these Terms. You may not use our Services:
          <ul>
            <li>In any way that violates applicable laws or regulations</li>
            <li>To exploit, harm, or attempt to harm others</li>
            <li>To interfere with or disrupt the Services or networks connected to them</li>
          </ul>
        </p>
        <h4>2. User Accounts</h4>
        <p>
          To access certain features, you may need to create an account. You agree to provide accurate information and to keep your login credentials secure. You are responsible for all activity under your account.
        </p>

        <h4>3. Intellectual Property</h4>
        <p>
          All content on our Services, including text, graphics, logos, and software, is the property of <strong>[BYTLAS INTELLIGENCE PRIVATE LIMITED]</strong> or its licensors and is protected by copyright and intellectual property laws.
        </p>

        <h4>4. Termination</h4>
        <p>
          We reserve the right to suspend or terminate your access to the Services at our discretion, without notice, if we believe you have violated these Terms.
        </p>

        <h4>5. Limitation of Liability</h4>
        <p>
          To the maximum extent permitted by law, <strong>[BYTLAS INTELLIGENCE PRIVATE LIMITED]</strong> is not liable for any indirect, incidental, or consequential damages resulting from your use of the Services.
        </p>

        <h4>6. Indemnification</h4>
        <p>
          You agree to indemnify and hold harmless <strong>[BYTLAS INTELLIGENCE PRIVATE LIMITED]</strong>, its affiliates, and its partners from any claims arising from your use of the Services or your violation of these Terms.
        </p>

        <h4>7. Modifications</h4>
        <p>
          We may revise these Terms from time to time. Any changes will be posted on this page with an updated effective date. Continued use of the Services after changes means you accept the revised Terms.
        </p>

        <h4>8. Governing Law</h4>
        <p>
          These Terms are governed by the laws of <strong>[India]</strong>, without regard to its conflict of law provisions.
        </p>

        <h4>9. Contact Us</h4>
        <p>
          If you have any questions about these Terms, please contact us at:
          <br />
          📧 <strong>Email:</strong> info@bytlasintelligence.com.com
          <br />
          🌐 <strong>Website:</strong> <a href="https://bytlasintelligence.com">https://bytlasintelligence.com</a>
        </p>
      </div>
    </div>
  );
}
